import { Flex, Icon, Select, Tooltip, Typography } from '@aloft/toolkit-sui';

import { Controller, FormProvider } from 'react-hook-form';

import { AddressInput } from '../../../../../components/AddressInput/AddressInput.js';
import { selectPropertyType } from '../../../../../redux/features/selectors/orderSelectors.js';
import { useAppSelector } from '../../../../../redux/hooks.js';
import { getPropertyTypeOptions } from '../getPropertyTypeOptions.js';
import { AddCompsFormProps } from '../types.js';

export function AddCompsForm({ form }: AddCompsFormProps) {
  const primaryPropertyType = useAppSelector(selectPropertyType) ?? 'singleFamilyResidence';
  const propertyTypeOptions = getPropertyTypeOptions({
    primaryPropertyType,
  });
  return (
    <Flex width="100%" height="100%" gap={3} flexDirection="column">
      <FormProvider {...form}>
        <Flex>
          <Typography variant="h3">Add Comparable</Typography>
          <Tooltip label="Toolkit will import data from your MLS and/or county records to autofill certain fields. You can still edit these fields.">
            <Flex marginLeft={1}>
              <Icon size="sm" icon="question" color="textSecondary" />
            </Flex>
          </Tooltip>
        </Flex>
        <Flex gap={3} flexDirection="column">
          <AddressInput />
          <Controller
            control={form.control}
            key="propertyType"
            name="propertyType"
            defaultValue={primaryPropertyType}
            render={({ field }) => {
              return (
                <Select
                  isRequired
                  label="Property Type"
                  {...field}
                  options={propertyTypeOptions}
                  onChange={(val) => {
                    field.onChange(val ?? 'singleFamilyResidence');
                  }}
                />
              );
            }}
          />
        </Flex>
      </FormProvider>
    </Flex>
  );
}
